module.exports = __webpack_public_path__ + "static/media/ic_sad_face.bdd6255f.svg";